// extracted by mini-css-extract-plugin
export default {"wrapper":"wOILk8o1IomP4hSCBC46","titleWrapper":"trBkL4RMNrQ_FVnSJgDS","subTitle":"pPhUZ6BDRSxa_g8QKBuM"};